module.exports = __webpack_public_path__ + "static/media/Oppfatte.03a86c38.m4a";